
export default {
  computed: {
    user () {
      return {
        id: this.$store.state.user.id,
        name: this.$store.getters['user/fullName'],
        photo: this.$store.state.user.data.photo,
      }
    },
  },
}
